import {Image} from '@coolcolduk/ui-image';
import {Grid, useMediaQuery, useTheme} from '@mui/material';
import {motion} from 'framer-motion';
import {PropsWithChildren} from 'react';

export interface LandingTemplateProps {
  src: string;
  isReverse?: boolean;
}

export default function LandingTemplate({isReverse, children, src}: PropsWithChildren<LandingTemplateProps>) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Grid
      container
      spacing={4}
      alignItems="center"
      direction={isReverse ? 'row-reverse' : 'row'}
      justifyContent="space-evenly"
      sx={{minHeight: '70vh'}}
    >
      <Grid
        container
        component={motion.div}
        sx={{width: isMd ? '40%' : '100%'}}
        initial={{opacity: 0, x: isReverse ? 50 : -50}}
        whileInView={{opacity: 1, x: 0}}
        transition={{duration: 0.8}}
      >
        <Image src={src} sx={{'& > img': {borderRadius: '16px'}}} />
      </Grid>
      <Grid
        container
        sx={{width: isMd ? '40%' : '100%'}}
        direction="column"
        component={motion.div}
        initial={{opacity: 0, x: isReverse ? -50 : 50}}
        whileInView={{opacity: 1, x: 0}}
        transition={{duration: 0.8}}
      >
        {children}
      </Grid>
    </Grid>
  );
}
